export default ({ sensorFiltersProps: { filters } }) => ({
  filters,
  limit: 30,
})
